import useStore from "../../../store"
import { useTranslation } from 'react-i18next'

export default function GraphRangeSelector() {
  const graphRange = useStore((state) => state.graphRange)
  const isGraphHappy = useStore((state) => state.isGraphHappy)
  const setGraphRange = useStore((state) => state.setGraphRange)
  const { t } = useTranslation()
  const options = ['1M', '3M', t('1Y')]

  const selectionButton = (option) => {
    const buttonColor = isGraphHappy ? 'bg-green' : 'bg-fpx-red'
    const buttonStyle = graphRange === option ? 
      `${buttonColor} px-1.5 rounded-full font-black decoration-4` : 
      "text-grey-300 px-1.5"

    return (
      <div 
        className={`hover:cursor-pointer ${buttonStyle}`}
        onClick={() => setGraphRange(option)}
        key={option}
      >
        {option}
      </div>
    )
  }

  return(
    <div className="flex justify-end lg:justify-normal pl-5 pb-2">
      <div className="flex justify-between w-1/2 text-sm pr-3 lg:pr-0">
        {options.map((o) => selectionButton(o))}
      </div>
    </div>
  )
}